import { api } from "@/services/api";

import { ProfileModel } from "../types";
import { PostCommentModel, PostModel } from "@/types/post";
import { MessageModel, RecipientModel } from "@/types/chat";

const accountApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccountList: build.mutation<ProfileModel[], void>({
      query: (payload) => {
        return {
          url: "api/Profile/GetProfileList",
          method: "get",
          data: payload,
        };
      },
    }),
    blockUnblockAccount: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Profile/BlockUnblockUser",
          method: "post",
          data: payload,
        };
      },
    }),
    confirmAccount: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Profile/ConfirmAccount",
          method: "post",
          data: payload,
        };
      },
    }),
    updateProfileSetting: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Profile/UpdateProfileSetting",
          method: "post",
          data: payload,
        };
      },
    }),
    getPosts: build.mutation<PostModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/GetPosts",
          method: "post",
          data: payload,
        };
      },
    }),
    updatePostStatus: build.mutation<PostModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/UpdatePostStatus",
          method: "post",
          data: payload,
        };
      },
    }),
    getUserComments: build.mutation<PostCommentModel[], any>({
      query: (payload) => {
        return {
          url: "api/Comment/GetUserComments",
          method: "post",
          data: payload,
        };
      },
    }),
    getUserRecipients: build.mutation<RecipientModel[], any>({
      query: (payload) => {
        return {
          url: "api/Chat/GetUserRecipients",
          method: "post",
          data: payload,
        };
      },
    }),
    getUserMessages: build.mutation<MessageModel[], any>({
      query: (payload) => {
        return {
          url: "api/Chat/GetUserMessages",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAccountListMutation,
  useBlockUnblockAccountMutation,
  useUpdateProfileSettingMutation,
  useGetPostsMutation,
  useUpdatePostStatusMutation,
  useGetUserCommentsMutation,
  useGetUserRecipientsMutation,
  useGetUserMessagesMutation,
  useConfirmAccountMutation,
} = accountApi;

export default accountApi;
